import { render, staticRenderFns } from "./embeddedHtmlBlock.vue?vue&type=template&id=1e3e8fa9&scoped=true&"
import script from "./embeddedHtmlBlock.vue?vue&type=script&lang=js&"
export * from "./embeddedHtmlBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3e8fa9",
  null
  
)

export default component.exports